import { SET_MEDIA } from '../actions/types';

export default function media(
	state = {
		images: [],
		imagesToDisplay: [],
		videoOrder: [],
		videos: {},
		galleryContent: {},
		failedImages: []
	},
	action
) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_MEDIA:
				return {
					...state,
					...action.payload
				};
			// no default
		}
	}

	return state;
}
